import { useEffect, useState } from 'react';
import { IDespesaFullDTO } from '../../../../models/happy-code-api.model';

export function useDimissAlert(despesa: IDespesaFullDTO, isEdit: boolean) {
	const isParcelamento = !!(isEdit && despesa?.planoFinanceiro?.id);
	const [isVisibleAlert, setIsVisibleAlert] = useState<boolean>(isParcelamento);
	const [isModalConfirm, setIsModalConfirm] = useState<boolean>(false)

  useEffect(() => {
		if (isParcelamento) {
			setIsVisibleAlert(true);
		}
	}, [isParcelamento]);

	return { isVisibleAlert, setIsVisibleAlert, isParcelamento, isModalConfirm, setIsModalConfirm };
}
